import { OneClickProductType } from "../../../Common/Constant";
import { SESSION_STORAGE_CLIENT_ACCOUNT_INFO, getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../../../sessionStorage";
import { insurancePolicyTypes } from "../../ABLTC/SubComponents/SelectOptions";
import { ConvertStringToBoolean } from "../../../Helpers/Formatters/ConvertBoolean";

const requestBody = (productType, productPages, userData, oneClickProductType, showAttestation) => {
  let requestData;
  const clientAcctInfo = getSessionStorageItem(SESSION_STORAGE_CLIENT_ACCOUNT_INFO);
  const accountDetails = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  let attestationPage = productPages.pages.attestation;
  if (attestationPage) {
    attestationPage.attestation = ConvertStringToBoolean(attestationPage.attestation);
  }

  requestData = {
    ...requestData,
    externalUserID: userData && userData.externalUserId,
    commonPages: {
      insuredBasicInfo: productPages.pages.insuredBasicInfo,
      retrieveAccount: productPages.pages.retrieveAccount,
      yourInformation: productPages.pages.yourInformation,
    },
    clientAccountInfo: { clientAccountInfoResponse: JSON.stringify(clientAcctInfo) },
    oneClickAccountID: accountDetails.account.oneClickAccountId,
  }

  switch (productType) {
    case 'TERM':
      requestData = {
        ...requestData,
        pages: {
          applicationInformation: productPages.pages.applicationInformation,
          quoter: productPages.pages.quoter,
          esign: productPages.pages.esign,
          attestation: attestationPage,
        },
      }
      break;

    case 'REQUEST_ILLUSTRATION':
      let pageData;
      if (oneClickProductType === OneClickProductType.MorganStanleyLTCQ) {
        const comparePage = { selectedQuotes: productPages.pages.quoter.selectedQuotes }
        const proposedInsuredInformation = productPages.pages.insuredBasicInfo.insuredInfo[0];

        requestData.commonPages.insuredBasicInfo = {
          proposedInsuredFirstName: proposedInsuredInformation.proposedInsuredFirstName,
          proposedInsuredMiddleInitial: proposedInsuredInformation.proposedInsuredMiddleInitial,
          proposedInsuredLastName: proposedInsuredInformation.proposedInsuredLastName,
          gender: proposedInsuredInformation.gender,
          maritalStatus: proposedInsuredInformation.maritalStatus,
          birthdate: proposedInsuredInformation.birthdate,
          state: proposedInsuredInformation.state,
          tobacco: proposedInsuredInformation.tobacco,
          county: proposedInsuredInformation.county,
          proposedInsuredEmail: proposedInsuredInformation.proposedInsuredEmail,
          proposedInsuredPhone: proposedInsuredInformation.proposedInsuredPhone,
          insuredRelationshipWithOwner: proposedInsuredInformation.insuredRelationshipWithOwner || '',
        };
        const isSurvivorshipPolicyType = productPages.pages.retrieveAccount.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP
        // if insurancePolicyType is Survivorship then add second insured

        if (isSurvivorshipPolicyType && productPages.pages.insuredBasicInfo.insuredInfo && productPages.pages.insuredBasicInfo.insuredInfo.length > 1) {
          const survivorshipInsuredInformation = productPages.pages.insuredBasicInfo.insuredInfo[1];
          requestData.commonPages.insuredBasicInfo = {
            ...requestData.commonPages.insuredBasicInfo,
            pi2FirstName: survivorshipInsuredInformation.proposedInsuredFirstName,
            pi2MiddleName: survivorshipInsuredInformation.proposedInsuredMiddleInitial,
            pi2LastName: survivorshipInsuredInformation.proposedInsuredLastName,
            pi2BirthDate: survivorshipInsuredInformation.birthdate,
            pi2MaritalStatus: survivorshipInsuredInformation.maritalStatus,
            pi2Gender: survivorshipInsuredInformation.gender,
            pi2State: survivorshipInsuredInformation.state,
            pi2County: survivorshipInsuredInformation.county,
            pi2UseTobacco: survivorshipInsuredInformation.tobacco,
            pi2Email: survivorshipInsuredInformation.proposedInsuredEmail,
            pi2Phone: survivorshipInsuredInformation.proposedInsuredPhone,
          }
        }

        pageData = {
          quoter: productPages.pages.quoter,
          compare: comparePage,
          clientCoverage: productPages.pages.clientCoverage,
        }
      }
      if (oneClickProductType === OneClickProductType.MorganStanleyULR) {
        pageData = {
          clientPreferences: productPages.pages.clientPreferences,
        }
      }

      requestData = {
        ...requestData,
        oneClickProductType: oneClickProductType,
        pages: { ...pageData },
      }
      break;

    case 'SUBMIT_ILLUSTRATION':
      const proposedInsuredInformation = productPages.pages.insuredBasicInfo;
      const filesFromSession = productPages.pages.replaceFile.file || null;
      let arrayOfFiles = [];

      requestData.commonPages.insuredBasicInfo = {
        proposedInsuredFirstName: proposedInsuredInformation.proposedInsuredFirstName,
        proposedInsuredMiddleInitial: proposedInsuredInformation.proposedInsuredMiddleInitial,
        proposedInsuredLastName: proposedInsuredInformation.proposedInsuredLastName,
        gender: proposedInsuredInformation.gender,
        maritalStatus: proposedInsuredInformation.maritalStatus,
        birthdate: proposedInsuredInformation.birthdate,
        state: proposedInsuredInformation.state,
        tobacco: proposedInsuredInformation.tobacco,
        proposedInsuredEmail: proposedInsuredInformation.proposedInsuredEmail,
        proposedInsuredPhone: proposedInsuredInformation.proposedInsuredPhone,
        insuredRelationshipWithOwner: proposedInsuredInformation.insuredRelationshipWithOwner || '',
      };

      const isSurvivorshipPolicyType = productPages.pages.retrieveAccount.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP
      // if insurancePolicyType is Survivorship then add second insured

      if (isSurvivorshipPolicyType) {
        requestData.commonPages.insuredBasicInfo = {
          ...requestData.commonPages.insuredBasicInfo,
          pi2FirstName: proposedInsuredInformation.secondaryInsuredFirstName,
          pi2MiddleName: proposedInsuredInformation.secondaryInsuredMiddleInitial,
          pi2LastName: proposedInsuredInformation.secondaryInsuredLastName,
          pi2BirthDate: proposedInsuredInformation.secondaryInsuredBirthdate,
          pi2MaritalStatus: proposedInsuredInformation.secondaryInsuredMaritalStatus,
          pi2Gender: proposedInsuredInformation.secondaryInsuredGender,
          pi2State: proposedInsuredInformation.secondaryInsuredState,
          pi2UseTobacco: proposedInsuredInformation.secondaryInsuredTobacco,
          pi2Email: proposedInsuredInformation.secondaryInsuredEmail,
          pi2Phone: proposedInsuredInformation.secondaryInsuredPhone,
          secondaryInsuredRelationshipWithOwner: proposedInsuredInformation.secondaryInsuredRelationshipWithOwner
        }
      }

      if (filesFromSession !== null) {
        filesFromSession.fileList.forEach((element) => {
          const objectToPush = {
            "fileName": element.name,
            "fileKey": element.key,
            "fileType": 2,
            "fileCarrierName": element.carrier,
          }
          arrayOfFiles.push(objectToPush);
        })
      }

      requestData = {
        ...requestData,
        pages: {
          replaceFile: productPages.pages.replaceFile,
          selectProduct: productPages.pages.selectProduct,
          applicationInformation: productPages.pages.applicationInformation,
          esign: productPages.pages.esign,
        },
      }

      if(showAttestation){
        requestData.pages = {
            ...requestData.pages,
            attestation: attestationPage,
          }
      }
      break;

    default:
      break;
  }
  return requestData;
}

export { requestBody }



// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/YourInformation/requestBody.js